import React from 'react';
import './landing.css';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
 import { Link } from "react-router-dom";
import Footer from "../../components/Footer";
import {SEO} from "../../components/SEO";

function Index() {
    return (
        <div>
            <SEO isDefault />
            <div className={'bg hidden md:flex justify-center w-2/6 absolute h-5/6 right-0 overflow-hidden bottom-0 z-0'}>
                    <img src={'pen.png'} alt={'ペン'} className={'absolute transform rotate-12 bottom-0 h-4/6'}/>
            </div>

            <div className={'bg-gradient absolute h-screen w-screen bg-gradient-to-b from-gray-200'}></div>

            <div className={'content h-screen w-screen pt-8 overflow-x-hidden'}>
                <div className={'App container mx-auto h-full'}>
                    <header className="App__header">
                        <h1 className="text-5xl font-dancing-script font-bold mx-4">
                            Ran Van de Wereld
                        </h1>
                        <h2 className="text-lg font-dancing-script mx-4">- hisayasahi -</h2>
                    </header>
                    <main className={'letter h-3/6 md:h-4/6 w-10/12 md:w-5/12 my-4 md:my-8 mx-auto'}>
                        <div className={'bg-gray-100 w-full h-full'}>
                            <Carousel className={'h-full'} autoPlay swipeable emulateTouch infiniteLoop interval={5000} showArrows={false} showStatus={false} showThumbs={false}>
                                <div>
                                  <img alt="傘をもった楓" src="illust/kaede-top.jpg" />
                                </div>
                                <div>
                                  <img alt="" src="illust/kyoushitsu1.jpg" />
                                </div>
                                <div>
                                  <img alt="" src="illust/top.jpg" />
                                </div>
                                <div>
                                  <img alt="" src="illust/top2.jpg" />
                                </div>
                                <div>
                                  <img alt="" src="illust/sunset.jpg" />
                                </div>
                                <div>
                                  <img alt="" src="illust/newyear2015.jpg" />
                                </div>
                                <div>
                                  <img alt="" src="illust/newyear2014.jpg" />
                                </div>
                                <div>
                                  <img alt="" src="illust/minna1.jpg" />
                                </div>
                            </Carousel>
                        </div>
                    </main>

                    <div className={'mx-8'}>
                        <p>当サイトの内容、テキスト、画像等の無断転載・無断使用を固く禁じます。</p>
                        <p>Unauthorized copying and replication of the contents of this site, text, and images are strictly prohibited.</p>
                    </div>

                    <Link to={'/home'}>
                        <button className={'fill-btn text-xl font-raleway my-4'}>Enter</button>
                    </Link>

                    <Footer />
                </div>
            </div>
        </div>
    );
}

export default Index;